<template>
  <el-dialog
     class="add-node common-dialog"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :before-close="handleCancel"
    :title="title"
  >
    <el-form
      ref="editForm"
      :model="editForm"
      :rules="editRules"
      :label-width="`${adaptationVars.formLabelWidth}px`"
      class="demo-ruleForm"
    >
      <el-form-item label="节点地址IP" prop="addr" >
        <el-input v-model="editForm.addr"></el-input>
      </el-form-item>
      <el-form-item label="节点名称" prop="name" >
        <el-input v-model="editForm.name"></el-input>
      </el-form-item>
      <el-form-item label="节点账户" prop="username" >
        <el-input v-model="editForm.username"></el-input>
      </el-form-item>
      <el-form-item label="节点密码" prop="password" >
        <el-input v-model="editForm.password" type="password"></el-input>
      </el-form-item>
      <el-form-item label="节点证书" prop="nodeCrtCid" >
        <el-select v-model="editForm.nodeCrtCid" placeholder="请选择" clearable class="auto-width">
          <el-option
            v-for="item in options"
            :key="item.id + item.NodeName"
            :label="item.NodeName"
            :value="String(item.id)"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="节点角色" prop="nodeRole" >
        <el-select v-model="editForm.nodeRole" placeholder="请选择" clearable class="auto-width">
          <el-option
            v-for="item in roleOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="运行区块链" prop="chainId">
        <el-input v-model="editForm.chainId"></el-input>
      </el-form-item>
      <el-form-item label="PATH" prop="path">
        <el-input v-model="editForm.path"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" :disabled="disabled" @click="handleOk()">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import adaptation from '@/mixins/adaptation'
export default {
  name: 'AddNode',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 100
  },
  data() {
    let validateNode = (rule, value, callback) => {
      let reg = /^(?!(\d+)$)[\u4e00-\u9fffa-zA-Z\d\-_.]{0,30}$/
      if (value === '') {
        callback(new Error('请输入节点名称'))
      } else if (!reg.test(value)) {
        callback(
          new Error('请输入30位以内字母、数字、汉字、中横线、下划线、小数点组合，不能为纯数字')
        )
      } else {
        callback()
      }
    }
    return {
      disabled: false,
      title: '增加节点',
      dialogVisible: false,
      editForm: {
        addr: '',
        name: '',
        username: '',
        password: '',
        nodeCrtCid: '',
        chainId: '',
        nodeRole: '',
        path: ''
      },
      editRules: {
        addr: [{ required: true, message: '请填写节点地址IP', trigger: 'blur' }],
        name: [{ required: true, validator: validateNode, trigger: 'blur' }],
        username: [{ required: true, message: '请输入节点账户', trigger: 'blur' }],
        password: [{ required: true, message: '请输入节点密码', trigger: 'blur' }],
        nodeCrtCid: [{ required: true, message: '请选择节点证书', trigger: 'blur' }],
        chainId: [{ required: true, message: '请输入运行区块链', trigger: 'blur' }],
        nodeRole: [{ required: true, message: '请选择节点角色', trigger: 'blur' }],
        path: [{ required: true, message: '请输入path', trigger: 'blur' }]
      },
      options: [],
      roleOptions: [
        { label: '共识节点', value: 'consensus' },
        { label: '普通节点', value: 'common' }
      ],
      adaptationVars: {
        formLabelWidth: 100
      }
    }
  },
  methods: {
    getOptions() {
      this.$apis.certificate.getNodeList({ limit: 50, offset: 0, certType: 1 }).then(res => {
        if (res.data && res.data.items) {
          this.options = res.data.items
        }
      })
    },
    handleCancel() {
      this.editForm = {
        addr: '',
        name: '',
        username: '',
        password: '',
        nodeCrtCid: '',
        chainId: '',
        nodeRole: ''
      }
      this.disabled = false
      this.$refs.editForm.clearValidate()
      this.dialogVisible = false
    },
    handleOpen() {
      this.getOptions()
      this.dialogVisible = true
    },
    handleOk() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.disabled = true
          this.$apis.node
            .createNode(this.editForm)
            .then(res => {
              if (res) {
                this.$emit('update:list')
                this.handleCancel()
              }
            })
            .catch(err => {
              this.disabled = false
            })
        } else {
          this.disabled = false
          this.$message.warning('请填写内容')
          return
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme('add-node', (), ());
.add-node {
  @include adaptation((
   
  ));
  /deep/ .el-dialog {
    width: var(--common-dialog-width);
  }

  .el-form {
    margin-right: var(--common-dialog-form-margin-right);
  }
}
</style>
